import { Component, OnInit } from '@angular/core';
import { ProductDto, ProductStatsStatusEnum, ProductStatsWrapperDto } from '../../../service/dto-insurance';
import { HttpInsuranceProductService } from '../../../service/http-insurance-product.service';
import { Router } from '@angular/router';

@Component({
	selector: 'app-finance-home',
	standalone: false,
	templateUrl: './finance-home.component.html',
	styleUrl: './finance-home.component.scss'
})
export class FinanceHomeComponent implements OnInit {
	products: ProductStatsWrapperDto[] = [];
	loading = true;

	constructor(private productService: HttpInsuranceProductService, private router: Router) { }

	ngOnInit(): void {
		this.loading = true;
		this.productService.getAllWithStats().subscribe({
			next: result => {
				this.products = result;
				this.loading = false;
			},
			error: () => this.loading = false
		});
	}
	getStatusColor(status: ProductStatsStatusEnum): string {
		switch (status) {
			case 'NeverRaised': return 'default';
			case 'ScheduleDue': return 'blue';
			case 'ScheduleOverdue': return 'red';
			case 'ScheduleUploaded': return 'green';
			default: return 'default';
		}
	}

	get totalPolicyCount(): number {
		return this.products.reduce((sum, w) => sum + w.policyCount, 0);
	}

	get scheduleDueCount(): number {
		return this.products.filter(w => w.status === 'ScheduleDue').length;
	}

	get scheduleOverdueCount(): number {
		return this.products.filter(w => w.status === 'ScheduleOverdue').length;
	}

	get totalRaisedPremium(): number {
		return this.products.reduce((sum, w) => sum + w.raisedPremium, 0);
	}
	get totalDuePremium(): number {
		return this.products.reduce((sum, w) => sum + w.outstandingPremiums - w.receivedPremium, 0);
	}
	get totalOutstandingPremium(): number {
		return this.products.reduce((sum, w) => sum + w.outstandingPremiums - w.receivedPremium - w.raisedPremium, 0);
	}

	open(input: ProductStatsWrapperDto) {
		this.router.navigate(['/finance', 'product', input.product.id]);
	}
}
